import React from 'react';
import getFormattedDate from '../../utils/date-format';
import { getTextColorByBG } from '../../utils/utils';

function PledgeConfirmation(props) {
    const primaryColor = props?.campaignDetail?.primary_color || '#009000';

    return (
        <div className={`row ${props?.formStep !== 'pledge-confirmation' ? 'd-none' : ''}`}>
            <div className="col-12 p-0">

                {/* Header */}
                <div className="text-center pt-1 m-0 rounded-top">
                    <i
                        className="fa-regular fa-circle-check"
                        style={{ fontSize: "60px", color: primaryColor }}
                    ></i>

                    <h5 className="text-dark mt-2">
                        You Have Pledged ${props?.returnSelectedAmount()}
                    </h5>
                </div>

                {/* Body */}
                <div className="p-4 rounded-bottom">

                    <div className="p-3 border text-center rounded" style={{ background: "#fff" }}>
                        Thank you for your pledge, please complete your donation as soon as you can.
                    </div>

                    <div className="row mt-4">
                        <div className="col-6">
                            <div className="border rounded p-3 h-100">
                                <small className="text-muted fw-bold">DATE</small>
                                <h6 className="mt-2 mb-0">
                                    {new Date().toDateString().split(" ")[0] + ' ' + getFormattedDate(new Date())}
                                </h6>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="border rounded p-3 h-100">
                                <small className="text-muted fw-bold">PLEDGE AMOUNT</small>
                                <h5 className="mt-2 mb-0" style={{ color: primaryColor }}>
                                    ${props?.returnSelectedAmount()}
                                </h5>
                            </div>
                        </div>
                    </div>

                    <button
                        className="btn w-100 mt-4"
                        style={{
                            backgroundColor: primaryColor,
                            color: getTextColorByBG(primaryColor),
                            borderColor: primaryColor,
                            borderRadius: "8px",
                        }}
                        onClick={() => {
                            window.open(props?.campaignDetail?.website ? props?.campaignDetail?.website : 'https://mymasjidal.com/', '_self', '');
                        }}
                        type="button">
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}

export default PledgeConfirmation;